import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/checkmark-white.svg'
import _imports_1 from '@/assets/icons/chevron-forward-gray.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_3 = { class: "container h-full py-8" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col h-full justify-between"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-row mb-4 -mt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Back")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex flex-row justify-between w-full" }
const _hoisted_11 = { class: "flex flex-col items-start" }
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = { class: "flex flex-row items-end mt-4" }
const _hoisted_15 = { class: "text-3xl font-bold" }
const _hoisted_16 = { class: "flex flex-row justify-between items-center w-full mt-4" }
const _hoisted_17 = { class: "flex flex-row items-center font-semibold" }
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  class: "w-3 h-3"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mx-4"
}, null, -1)
const _hoisted_23 = { class: "flex flex-col items-end justify-between" }
const _hoisted_24 = {
  key: 0,
  class: "bg-orange-100 text-orange-400 rounded-full px-4 py-2"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flex flex-row items-center" }
const _hoisted_27 = {
  key: 0,
  class: "flex flex-row justify-center mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/payroll'))),
                    class: "btn-outline-lg"
                  }, _hoisted_8)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePayrolls, (payroll, i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: i,
                    onClick: ($event: any) => (_ctx.$router.push(`/payroll/${_ctx.company_id}/${payroll.id}`)),
                    class: _normalizeClass(["flex flex-col bg-white shadow rounded-2xl p-8 items-start justify-start", {
                'border border-primary':
                  payroll.stripe_invoice_status === 'in_process',
                'mt-4': i > 0,
              }])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(payroll.company.visible_name) + " Payroll: ", 1),
                          _createVNode(_component_DateFormatter, {
                            date: payroll.start_date
                          }, null, 8, ["date"]),
                          _hoisted_13,
                          _createVNode(_component_DateFormatter, {
                            date: payroll.end_date
                          }, null, 8, ["date"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createTextVNode(_toDisplayString(payroll.payrolls_exchange_rate_mxn) + " ", 1),
                          _createElementVNode("span", _hoisted_15, " $" + _toDisplayString((payroll.payrolls_total / 100).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )) + " USD ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center bg-gray-200 w-6 h-6 rounded-full mr-4", {
                          'bg-secondary':
                            payroll.stripe_invoice_status === 'in_process',
                          'bg-green-500':
                            payroll.stripe_invoice_status === 'paid',
                        }])
                            }, [
                              (payroll.stripe_invoice_status === 'paid')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                : _createCommentVNode("", true)
                            ], 2),
                            (payroll.stripe_invoice_status === 'in_process')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Waiting for automatic payment "))
                              : (payroll.stripe_invoice_status === 'paid')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Paid "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, " Waiting for invoice ")),
                            _hoisted_22,
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-6 h-6 bg-gray-200 rounded-full mr-4", {
                          'bg-secondary':
                            payroll.stripe_invoice_status === 'paid',
                        }])
                            }, null, 2),
                            _createElementVNode("span", {
                              class: _normalizeClass({
                          'text-gray-400':
                            payroll.stripe_invoice_status === 'in_process',
                          'text-automatic':
                            payroll.stripe_invoice_status === 'paid',
                        })
                            }, " Pay stubs delivered ", 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        (payroll.pending_reimbursement_clarifications)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Pending clarification "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25)),
                        _createElementVNode("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payroll.users.slice(0, 5), (emp, j) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: j,
                              class: "flex justify-center items-center bg-primary text-white rounded-full w-10 h-10 mx-2"
                            }, _toDisplayString(emp.first_name[0]) + _toDisplayString(emp.last_name[0]), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 10, _hoisted_9))
                }), 128))
              ]),
              (_ctx.payrolls.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_v_pagination, {
                      modelValue: _ctx.currentPage,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
                      pages: _ctx.pagination.total_pages,
                      "range-size": 1,
                      "active-color": "#8908F9"
                    }, null, 8, ["modelValue", "pages"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
}